import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type {
  ExternalProviderRepository,
  InitializeContractBody,
} from "@shared-kernel/application/ports/external-provider/external-provider-repository";

interface InitializeContractCommand {
  externalProviderRepository: ExternalProviderRepository;
  body: InitializeContractBody;
}

export const initializeContract = createApiThunk<string, InitializeContractCommand>(
  "externalProvider/initializeContract",
  async ({ externalProviderRepository, body }: InitializeContractCommand) => {
    return externalProviderRepository.initializeContract(body);
  },
);

export const resetInitializeContract = createAction("externalProvider/resetInitializeContract");
